import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import * as styles from "./SplitView.scss";

export interface ISplitViewProps {
    className?: string;
    view: ReactNode;
    summary: ReactNode;
}

export class SplitView extends Component<ISplitViewProps> {
    public render() {
        const { className, view, summary } = this.props;

        return (
            <div className={classnames(styles["split-view"], className)}>
                <div className={styles.view}>{view}</div>
                <div className={styles.summary}>
                    <div className={styles.content}>{summary}</div>
                </div>
            </div>
        );
    }
}
